// Orden y fusión de notificaciones, compartidos por el centro (useNotificationHistory)
// y la campana (useNotifications). Mismo contrato que el backend
// (docs/notificaciones-orden-agrupacion-react-native.md).

// Orden del centro: created_at desc y, si empatan, id desc. NO por id a secas: el id no
// sigue a la fecha (una notificación reabierta, o a la que se le suma un evento, conserva
// su id y toma el created_at de ahora). created_at llega como "YYYY-MM-DD HH:MM:SS" y se
// compara como texto.
export const byDateDesc = (a, b) => {
  const ca = a.created_at || '';
  const cb = b.created_at || '';
  if (ca === cb) return b.id - a.id;
  return ca < cb ? 1 : -1;
};

export const sortNotifications = (items) => [...items].sort(byDateDesc);

// Reemplaza por id (la versión que llega MANDA sobre la que ya había) o agrega, y deja la
// lista en el orden del centro. Es la única regla para el socket, las páginas y la
// reconciliación: una fila agrupada llega con su mismo id y un count nuevo, y tiene que
// reemplazar a la anterior y subir al tope, no duplicarse ni quedarse como estaba.
// `count` ausente (servidor o respuesta vieja) vale 1.
export const upsertNotifications = (items, incoming) => {
  const byId = new Map(items.map((n) => [n.id, n]));
  [].concat(incoming).forEach((n) => byId.set(n.id, { count: 1, ...n }));
  return sortNotifications([...byId.values()]);
};

// Ids en bloques de 50, el máximo que acepta mark-as-viewed con notification_ids.
export const chunkIds = (ids, size = 50) => {
  const out = [];
  for (let i = 0; i < ids.length; i += size) out.push(ids.slice(i, i + size));
  return out;
};
